import { FunctionComponent, useEffect } from "react";
import { refreshSessionAction } from "@store/auth/actions/refreshSessionAction";
import { createEntityViewAnalytics } from "@lib/helpers/createEntityViewAnalytics";
import { Drawer } from "../../flyouts/Drawer/Drawer";
import { SegmentedCommunications } from "@modules/segmentedViews/SegmentedCommunications";
import { useAppDispatch, useAppSelector } from "@store/store";
import { Toast } from "@ui-kit/Toast/Toast";
import { Header } from "@modules/account/Header/Header";
import { MenuItems } from "@modules/navigation/MenuItems/MenuItems";
import { Map } from "../../Map/Map";
import { AudioPlayer } from "@modules/media/AudioPlayer/AudioPlayer";
import { VideoPlayer } from "@modules/media/VideoPlayer/VideoPlayer";
import { GdprCookieBanner } from "@modules/components/banners/GdprCookieBanner/GdprCookieBanner";
import { useShowGdprCookieBanner } from "../../../hooks/useShowGdprCookieBanner/useShowGdprCookieBanner";
import { Onboarding } from "@modules/onboarding/Onboarding";
import { KioskHome } from "@modules/kiosk/KioskHome/KioskHome";
import { selectClient } from "@store/client/clientReducer";
import { SessionCountdown } from "@modules/kiosk/SessionCountdown/SessionCountdown";
import { NewPlanBanner } from "@modules/components/banners/NewPlanBanner/NewPlanBanner";
import { AppSmartBanner } from "@modules/appSmartBanner/AppSmartBanner/AppSmartBanner";
import { useGetAdsQuery } from "@store/services/ad";
import { PageAnalytics } from "@modules/navigation/PageAnalytics/PageAnalytics";
import { EntityListContainer } from "@modules/entityList/EntityListContainer/EntityListContainer";
import { OverlayRouter } from "@modules/overlayRouter/OverlayRouter";
import { TripBuilder } from "@modules/tripBuilder/TripBuilder";
import { EntityListBottomSheet } from "@modules/entityListBottomSheet/EntityListBottomSheet";
import { MobileScreenRouter } from "@modules/mobileScreenRouter/MobileScreenRouter";

import "./RootStyles.css";

const App: FunctionComponent<{}> = () => {
  const dispatch = useAppDispatch();
  const client = useAppSelector(selectClient);

  // fetch ads
  useGetAdsQuery();

  useEffect(() => {
    // first page load is done via ruby, any subsequent page changes are handled in flyout js
    createEntityViewAnalytics();
  }, []);

  useEffect(() => {
    // set user based on cookies if present on page load
    dispatch(refreshSessionAction());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showGdprCookieBanner = useShowGdprCookieBanner();

  return (
    <>
      {client.kioskFeature.homeMenuEnabled && <KioskHome />}
      {client.kioskFeature.enabled && <SessionCountdown />}
      <AppSmartBanner />
      <Header />
      <div id="main-content">
        <Map />
        <MenuItems />
        <EntityListContainer />
        {client.kioskFeature.enabled && <NewPlanBanner />}
        {showGdprCookieBanner && <GdprCookieBanner />}
      </div>
      <Drawer />
      <SegmentedCommunications />
      <AudioPlayer />
      <VideoPlayer />
      <Onboarding />
      <TripBuilder />
      <Toast />
      <PageAnalytics />
      <OverlayRouter />
      <EntityListBottomSheet />
      <MobileScreenRouter />
    </>
  );
};

export { App };
